'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _freeRegularSvgIcons = require('@fortawesome/free-regular-svg-icons');

var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');

require('../Carousel.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var generateIndicators = function generateIndicators(items, index, setIndex, color) {
  var indicators = [];

  var _loop = function _loop(i) {
    indicators.push(_react2.default.createElement(
      'button',
      {
        className: i === index ? 'carousel-indicator-selected' : 'carousel-indicator',
        onClick: function onClick() {
          return setIndex(i);
        },
        color: color,
        key: i
      },
      _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: i === index ? _freeSolidSvgIcons.faCircle : _freeRegularSvgIcons.faCircle, size: 'xs' })
    ));
  };

  for (var i = 0; i < items; i++) {
    _loop(i);
  }
  return indicators;
};

var Indicators = function (_React$Component) {
  _inherits(Indicators, _React$Component);

  function Indicators() {
    _classCallCheck(this, Indicators);

    return _possibleConstructorReturn(this, (Indicators.__proto__ || Object.getPrototypeOf(Indicators)).apply(this, arguments));
  }

  _createClass(Indicators, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          items = _props.items,
          index = _props.index,
          setIndex = _props.setIndex,
          color = _props.color;

      return _react2.default.createElement(
        'div',
        { className: 'carousel-indicator-container' },
        generateIndicators(items, index, setIndex, color)
      );
    }
  }]);

  return Indicators;
}(_react2.default.Component);

exports.default = Indicators;


Indicators.propTypes = {
  items: _propTypes2.default.number.isRequired,
  index: _propTypes2.default.number.isRequired,
  setIndex: _propTypes2.default.func.isRequired,
  color: _propTypes2.default.string.isRequired
};